/*eslint-disable */
import root from '../_helpers/roots';
import Vue from 'vue'
import router from '../route';
import toast from '../services/toast';
import axios from 'axios';
let getAssignmentListUrl = root.getAssignmentList.link;
let singleAssignmentUrl = root.getSingleAssignmentlink.link;
let addCommentUrl = root.uploadCommentAssignmentSolutionLink.link;
let uploadAssignmentFile = root.uploadFileAssignmentSolutionLink.link;
export default {
    state: {
        assignmentListState: {},
        singleAssignmentState: {},
        addCommentState: {},
        addSolutionFile: {},
        addAssignmentByNumber: {}
    },
    mutations: {
        getAssignments(state, value){
            state.assignmentListState = value;
          
        },
        getSingleAssignment(state, value){
            state.singleAssignmentState = value
        },
        getCommentResponse(state, value){
            state.addCommentState = value;
        },
        getSolutionFileResponse(state, value){
            state.addSolutionFile = value
        },
       setAssignmentByNumber(state, value){
           state.addAssignmentByNumber = value;
       }
    },
    actions: {
        getAssignmentActn(context){
            return new Promise((resolve, reject) => {
                axios.get(getAssignmentListUrl).then((res) => {
                    if(res.status == '401' || res.status == '403'){
                        router.push('/login')
                   }else{
                        if(res.data.code == '2000'){
                            context.commit('getAssignments', res.data.data.results);
                            resolve(res);
                        }else{

                        }
                   }  
                }).catch((err) => { 
                    reject(err);
                })
            });
        },
        getSignleAssignmentActn(context, payload){
           let singleAssignmentUrlcmplt = singleAssignmentUrl + payload.id+'/'
            return new Promise((resolve, reject) => {
                axios.get(singleAssignmentUrlcmplt).then((res) => {
                     
                    if(res.status == '401' || res.status == '403'){
                        router.push('/login')
                   }else{
                        if(res.data.code == '2000'){
                            context.commit('getSingleAssignment', res.data.data);
                        }
                   }

                   resolve(res);
                     
                }).catch((err) => { 
                    reject(err);
                })
            });
        },

        addCommentResponse(context, payload){
            return new Promise((resolve, reject) => {
                axios.post(addCommentUrl, payload).then((res) => {
                   if(res.status == '201'){
                       context.commit('getCommentResponse', res.data.data)
                       resolve(res);
                   }
                }).catch((err) => { 
                    reject(err);
                })

                
            });
        },
        addSolutionFileResponse(context, payload){
            return new Promise((resolve, reject) => { 
                axios.post(uploadAssignmentFile, payload, {
			        form: true,
                    headers: {
                      'Content-Type': null
                    }
                }).then((res) => { 
                    if(res.status == '401' || res.status == '403'){
                        router.push('/login')
                   }
                   else if(res.status == '413'){
                    toast.error(res.data.msg)
                   }
                   else if(res.status == '201'){
                        context.commit('getSolutionFileResponse', res.data.data);
                        toast.success(res.data.msg)
                        
                    }

                    resolve(res);
                             
                }).catch((err) => { 
                    reject(err);
                })
            });
        },
        getAssignmentByNumber(context, payload){
            return new Promise((resolve,reject)=>{
                axios.get(getAssignmentListUrl+'?page_size=5').then((response)=>{
                    if(response.status != '401' && response.status != '403' ){
                        context.commit('setAssignmentByNumber', response.data.data);
                        
                    }else{
                        router.push('/login')
                    }

                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
            })
        },
    },
    getters: {
        getAssignmentList: state => state.assignmentListState,
        singleAssignment: state => state.singleAssignmentState,
        getCommentGetter: state => state.addCommentState,
        assignmentByNumber: state => state.addAssignmentByNumber
    }
}